import axios from 'axios';
import { type BaseApiCallOptions } from './httpHelper';

function create(config: BaseApiCallOptions = {
  baseURL: 'http://localhost:8081',
  timeout: import.meta.env.VITE_API_TIMEOUT_MS,
  timeoutErrorMessage: 'İstek zaman aşımına uğradı, lütfen tekrar deneyiniz.',
}) {
  return axios.create({
    ...config,
  });
}

const baseGwClient = create();
export default baseGwClient;
